import { Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { bool_type, option_type, class_type, array_type, float64_type, record_type, int32_type, string_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { PlanePipeline_$reflection } from "../CenterlineMeasurement/CenterlineMeasurementBindings.js";
import { DicomViewMode_$reflection } from "../Common/CommonTypes.js";

export class UnifiedBranchReturn extends Record {
    constructor(branch, index) {
        super();
        this.branch = branch;
        this.index = (index | 0);
    }
}

export function UnifiedBranchReturn_$reflection() {
    return record_type("RAWMap.Client.Visualization.SlicePlane.Bindings.UnifiedBranchReturn", [], UnifiedBranchReturn, () => [["branch", string_type], ["index", int32_type]]);
}

export class SliceValues extends Record {
    constructor(index, maxIndex, bounds) {
        super();
        this.index = index;
        this.maxIndex = maxIndex;
        this.bounds = bounds;
    }
}

export function SliceValues_$reflection() {
    return record_type("RAWMap.Client.Visualization.SlicePlane.Bindings.SliceValues", [], SliceValues, () => [["index", float64_type], ["maxIndex", float64_type], ["bounds", array_type(float64_type)]]);
}

export class SliceCenterlinePlane extends Record {
    constructor(PlanePipeline, CenterlinePlaneUpdater) {
        super();
        this.PlanePipeline = PlanePipeline;
        this.CenterlinePlaneUpdater = CenterlinePlaneUpdater;
    }
}

export function SliceCenterlinePlane_$reflection() {
    return record_type("RAWMap.Client.Visualization.SlicePlane.Bindings.SliceCenterlinePlane", [], SliceCenterlinePlane, () => [["PlanePipeline", PlanePipeline_$reflection()], ["CenterlinePlaneUpdater", class_type("RAWMap.Client.Visualization.CenterlineMeasurement.Bindings.ICenterlineMeasurementUpdater")]]);
}

export class SlicePlaneProps extends Record {
    constructor(index, maxIndex, bounds, isVisible, isDisabled, centerlinePlane, dicomViewMode) {
        super();
        this.index = index;
        this.maxIndex = maxIndex;
        this.bounds = bounds;
        this.isVisible = isVisible;
        this.isDisabled = isDisabled;
        this.centerlinePlane = centerlinePlane;
        this.dicomViewMode = dicomViewMode;
    }
}

export function SlicePlaneProps_$reflection() {
    return record_type("RAWMap.Client.Visualization.SlicePlane.Bindings.SlicePlaneProps", [], SlicePlaneProps, () => [["index", option_type(float64_type)], ["maxIndex", option_type(float64_type)], ["bounds", option_type(array_type(float64_type))], ["isVisible", bool_type], ["isDisabled", bool_type], ["centerlinePlane", option_type(SliceCenterlinePlane_$reflection())], ["dicomViewMode", DicomViewMode_$reflection()]]);
}

